module.exports = __webpack_public_path__ + "static/img/suspension_en.c149620a.png";